import { PhoneSchema } from "@/utils/commonSchema";
import { captureException } from "@sentry/nextjs";
import {
  type InferOutput,
  email,
  literal,
  nonEmpty,
  null_,
  objectAsync,
  pipe,
  safeParseAsync,
  string,
  transform,
  trim,
  unionAsync,
} from "valibot";
import { getFromLocalStorage, setToLocalStorage } from "./safeLocalStorage";

export const UserInfoSchema = objectAsync({
  email: pipe(
    string("Veuillez saisir une adresse email valide."),
    trim(),
    nonEmpty("Veuillez saisir une adresse email valide."),
    email("Veuillez saisir une adresse email valide."),
  ),
  telephone: unionAsync([
    pipe(
      literal(""),
      transform(() => null),
    ),
    PhoneSchema,
    null_(),
  ]),
});

export type UserInfoData = InferOutput<typeof UserInfoSchema>;

export const getUserInfo = async (): Promise<UserInfoData | null> => {
  try {
    const userInfo = await safeParseAsync(UserInfoSchema, JSON.parse(getFromLocalStorage("userInfo") || "{}"));
    console.log("Parsed user info from local storage:", userInfo);
    if (userInfo.success) return userInfo.output;
    return null;
  } catch (error) {
    captureException(error);
    return null;
  }
};

export const setUserInfo = (userInfo: UserInfoData): void => {
  try {
    setToLocalStorage("userInfo", JSON.stringify(userInfo));
  } catch (error) {
    captureException(error);
  }
};
